import { useEffect } from 'react';
import { useIsDriver } from '../../hooks/useIsDriver';
import { useSoundStore } from '../../store/sceneStore';

const soundList = {
	/* from server */
	traffic_red: new Audio('asset/sound/newVersion/redlight.mp3'),
	traffic_green: new Audio('asset/sound/newVersion/greenlight.mp3'),
	traffic_warning: new Audio('asset/sound/newVersion/warning.mp3'),
	traffic_front: new Audio('asset/sound/newVersion/frontTrafficlight.mp3'),
	traffic_check: new Audio('asset/sound/newVersion/checkTrafficlight.mp3'),
	start_ad: new Audio('asset/sound/newVersion/startAD.mp3'),
	end_ad: new Audio('asset/sound/newVersion/endAD.mp3'),
	introduction: new Audio('asset/sound/newVersion/introduction.mp3'),
	/* from client */
	select_destination: new Audio('asset/sound/newVersion/selectDestination.mp3'),
	greeting: new Audio('asset/sound/newVersion/greeting.mp3'),
	// accept_server: new Audio('asset/sound/acceptServer.mp3'),
	// connect_server: new Audio('asset/sound/connectServer.mp3'),
	// status_server: new Audio("asset/sound/statusServer.mp3"),
	// request_server: new Audio('asset/sound/requestServer.mp3'),
	// cancel_server: new Audio("asset/sound/cancelServer.mp3"),
	// child_safety_zone: new Audio('asset/sound/childSafetyZone.mp3'),
	// arrive_destination: new Audio('asset/sound/arrive.mp3'),
};

const stopSound = (sound) => {
	sound.pause();
	sound.currentTime = 0.0;
};

const stopAllSound = () => {
	for (const key in soundList) {
		stopSound(soundList[key]);
	}
};

const playSoundElement = async (array, event) => {
	for (let i = 0; i < array.length; i++) {
		const soundName = array[i];
		const sound = soundList[soundName];

		await new Promise((resolve) => {
			sound.addEventListener('ended', () => {
				sound.removeEventListener('ended', sound);
				if (event[soundName]) event[soundName]();
				resolve('');
			});
			sound.play();
		});
	}
};

const useSoundManager = () => {
	const isDriver = useIsDriver();
	const sound = useSoundStore();

	useEffect(() => {
		if (sound && sound.method !== '' && isDriver) {
			const isNotGreeting = soundList['greeting'].paused;
			const isNotIntroduction = soundList['introduction'].paused;
			if (isNotGreeting && isNotIntroduction) {
				stopAllSound();
				playSoundElement(sound.sound_list, sound.end_event);
			}
		}
	}, [sound, isDriver]);
};

export default useSoundManager;
